export { default } from "./SelectableCard-component";
